import { Search } from '@/DTOS/CompanyGroup/Search';
import request from '../../utils/request';

const CompanyGroupService = {
  search: (search: Search) => {
    return request('/companyGroup/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; isActive: any; }} */ formData: {
      name: any;
      isActive: any;
    }
  ) => {
    return request('/companyGroup/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default CompanyGroupService;
